const Cookies = () => {
    return (
        <section className="py-10 sm:py-16">
            <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
                <div className="max-w-3xl mx-auto text-center">
                    <h2 className="text-3xl font-bold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-[#dbc7a6] via-[#3d4957] to-[#282e3a] sm:text-4xl lg:text-5xl p-3">
                        Cookies Policy
                    </h2>
                </div>

                <div className="py-4 container text-center">
                    <p className="py-2">
                        With each of your visits to our website or app, we may
                        automatically collect the following information: •
                        Technical information, including the Internet protocol
                        (IP) address used to connect your computer to the
                        Internet, browser type and version, time zone setting,
                        location; browser plug-in types and versions, operating
                        system, as well as the admin system and aggregated data
                        reports. That data is statistical in nature and tells us
                        about the navigational behaviour and actions of our
                        users and does not divulge any information about the
                        identity of any individual; and • Information about your
                        visit; services you viewed or searched for; page
                        response times, download errors, length of visits, page
                        interaction information (such as scrolling, clicks, and
                        mouse-overs); and • In addition, we may use third party
                        services such as Google Analytics that collect, monitor
                        and analyze information about Demographics and
                        Navigational Behaviour. Demographics may include
                        information such as gender, country of provenance and
                        age. Navigational Behaviour may include information such
                        as pages viewed during a session, time spent on a given
                        page and engagement with the Site's content such as
                        clicks and form submissions (e.g. an email subscription
                        to our newsletter).
                    </p>
                    <p className="py-2">
                        For that same reason, we can obtain information about
                        your general use of the internet using cookie files,
                        which are small files that are sent to us and which are
                        stored in your computer or other device's hard drive.
                        The cookies help us improve our Site as well as provide
                        a better and more personalized service. They allow us
                        to: • Estimate the size and nature of our audience as
                        well as its behavioural tendencies on our Site • Store
                        information about our users' preferences, which allows
                        us to personalize our Site in conjunction with
                        individual interests • Accelerate your search •
                        Recognize you when you come back on our Site
                    </p>
                    <p className="py-2">
                        If you wish to remove cookies, you can deactivate
                        cookies within your browser's parameters. However, if
                        you deactivate your cookies, you might not be able to
                        access some parts of our Site. We offer a free app for a
                        variety of mobile devices. The app processes the
                        personal details you give us in much the same way as our
                        website does. With your consent, we may send you push
                        notifications with information. You may grant us access
                        to your location data or contact details in order to
                        provide services requested by you. Please read the
                        instructions of your mobile device to understand how to
                        change the settings and enable the sharing of such data
                        or the receipt of push notifications.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Cookies;
